import TabPanel, {Tab} from '../../components/TabPanel'
import SetupIAMPolicyCLI from './_03_setup_iam_policy_cli.mdx'
import SetupIAMPolicyConsole from './_03_setup_iam_policy_console.mdx'

### Set up IAM policy

You need to set up an IAM policy for the instance where the collector will run,
so that the collector can access RDS information.

<TabPanel>
  <Tab id="cli" label="CLI" textContent>
    <SetupIAMPolicyCLI />
  </Tab>
  <Tab id="console" label="console" textContent>
    <SetupIAMPolicyConsole />
  </Tab>
</TabPanel>

This policy grants the following access:

- RDS metadata used to discover general instance information
- Cloudwatch metrics to show CPU utilization and other system metrics in pganalyze
- RDS log file download (for [pganalyze Log Insights](https://pganalyze.com/log-insights))

To learn more about each access, see [Amazon RDS and Aurora: IAM Policy](https://pganalyze.com/docs/install/amazon_rds/iam_policy).
